import { I18NService, XRouter, XUIBundle } from "@bluelibs/x-ui";
import * as Routes from "./routes";
import { Bundle } from "@bluelibs/core";
import { AppGuardian } from "./services/AppGuardian";
import { i18n } from "./i18n";
import * as ComponentOverrides from "./overrides";
export class UIAppBundle extends Bundle {
    async init() {
        var _a;
        const xui = this.container.get(XUIBundle);
        const i18nService = this.container.get(I18NService);
        const DEFAULT_LOCALE = "ro";
        i18nService.setLocale((_a = localStorage.getItem("ln")) !== null && _a !== void 0 ? _a : DEFAULT_LOCALE);
        xui.updateComponents({
            ...ComponentOverrides,
        });
        xui.setGuardianClass(AppGuardian);
        xui.storeI18N(i18n);
        // All routes are added via the routing service
        const router = this.container.get(XRouter);
        router.add(Routes);
    }
}
